import { AssetFeed } from '../components/assets/AssetFeed';

export function AssetsPage() {
  return <AssetFeed variant="library" showSearch showUpload />;
}
